"use strict";

exports.__esModule = true;
exports.shallowCloneElement = void 0;
/**
 * Shallowly clone a layout element.
 */
var shallowCloneElement = exports.shallowCloneElement = function shallowCloneElement(input) {
  return {
    type: input.type,
    props: Object.assign({}, input.props),
    children: input.children.slice()
  };
};